"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeObjectRecord;

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var Identifiable = _interopRequireWildcard(require("../protocol/Identifiable"));

var _immutable = require("immutable");

var _PropertyValueRecord = _interopRequireDefault(require("../property/PropertyValueRecord"));

var EMPTY_TOSTRING = '-';

var mapProperty = function mapProperty(record, property) {
  if (!record) {
    return undefined;
  }

  return record.getIn(['properties', property, 'value']);
};

var join = function join(arr) {
  var joined = arr.join(' ').trim();

  if (joined === '') {
    return null;
  }

  return joined;
};

var prepStrings = function prepStrings(record, _ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary;

  if (!primary) {
    primary = [];
  }

  if (!secondary) {
    secondary = [];
  }

  var mapPropertyForRecord = mapProperty.bind(null, record);
  var primaryString = join(primary.map(mapPropertyForRecord));
  var secondaryString = join(secondary.map(mapPropertyForRecord));
  return {
    primary: primaryString,
    secondary: secondaryString
  };
};

function makeObjectRecord(_ref2) {
  var idKey = _ref2.idKey,
      recordName = _ref2.recordName,
      objectType = _ref2.objectType,
      defaults = _ref2.defaults;
  var toStringOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ObjectRecord = (0, _immutable.Record)(defaults, recordName);
  Object.defineProperty(ObjectRecord, '_idKey', {
    value: idKey
  });
  Object.defineProperty(ObjectRecord, '_objectType', {
    value: objectType
  });

  ObjectRecord.toString = function toString(record) {
    if (!record) {
      return EMPTY_TOSTRING;
    }

    var _prepStrings = prepStrings(record, toStringOptions),
        primary = _prepStrings.primary,
        secondary = _prepStrings.secondary;

    return primary || secondary || EMPTY_TOSTRING;
  };

  ObjectRecord.toStringExpanded = function toStringExpanded(record) {
    if (!record) {
      return EMPTY_TOSTRING;
    }

    var _prepStrings2 = prepStrings(record, toStringOptions),
        primary = _prepStrings2.primary,
        secondary = _prepStrings2.secondary;

    var returnString = '';

    if (primary) {
      returnString = primary;

      if (secondary) {
        return returnString + " (" + secondary + ")";
      }

      return returnString;
    }

    if (secondary) {
      return secondary;
    }

    return EMPTY_TOSTRING;
  };

  ObjectRecord.fromJS = function (json) {
    if (json === null || json === undefined) {
      return json;
    }

    var immutable = (0, _immutable.fromJS)(json);

    if (immutable.has('properties')) {
      immutable = immutable.update('properties', function (properties) {
        return properties.map(_PropertyValueRecord.default.fromJS);
      });
    }

    return ObjectRecord(immutable);
  };

  Identifiable.getId.implement(ObjectRecord, (0, _getIn.default)(idKey));
  return ObjectRecord;
}

module.exports = exports.default;